import * as React from 'react';
import { CheckCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import { Button } from '../button';
import { Heading } from '@restworld/ui-ds-base';

import { cn } from '@restworld/utils-common';
export function EmployerCollaboratorFeedbackScreen({
  title,
  cta,
  content,
  iconVariant = 'success',
  noTopIcon,
}: EmployerCollaboratorFeedbackScreenProps) {
  return (
    <Wrapper>
      {noTopIcon ? null : iconVariant === 'success' ? (
        <CheckCircleIcon className="h-6 w-6 text-green-500" />
      ) : (
        <InformationCircleIcon className="h-6 w-6 text-neutral-700" />
      )}
      <Heading size={5} weight="semibold" color="neutral" className="text-lg lg:text-xl mt-8">
        {title}
      </Heading>
      {content && <ContentWrapper className=" mt-8">{content}</ContentWrapper>}
      <ContentWrapper className="mt-16">
        {cta && (
          <Button onClick={cta?.onClick} fullwidth>
            {cta?.title}
          </Button>
        )}
      </ContentWrapper>
    </Wrapper>
  );
}
export default EmployerCollaboratorFeedbackScreen;

export interface EmployerCollaboratorFeedbackScreenProps {
  title: string;
  content?: string;
  cta?: { title?: string; onClick?: () => void };
  iconVariant?: 'success' | 'info';
  noTopIcon?: boolean;
}

const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'h-full w-full max-w-[640px] mx-auto flex flex-col justify-center items-center text-center',
      className
    )}
    {...props}
  />
);
const ContentWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <p className={cn('text-neutral-200 font-medium max-w-[576px] lg:min-w-[576px]', className)} {...props} />
);
